import React, { useEffect } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";

import AdminLayout from "layouts/admin";
import AuthLayout from "layouts/auth";
import { useDispatch, useSelector } from "react-redux";
import Auth from "store/slice/auth";

const App = () => {
  const auth = Auth();
  const dispatch = useDispatch();
  const location = useLocation();

  const carStorageString = localStorage.getItem("car-meet-storage");
  const carMeetStorage = JSON.parse(carStorageString);

  useEffect(() => {
    if (carMeetStorage && carMeetStorage.token) {
      auth.setToken(carMeetStorage.token);
    }
    if (carMeetStorage && carMeetStorage.isLoggedIn) {
      dispatch(
        auth.setLoggedIn(
          JSON.parse(carMeetStorage && carMeetStorage.isLoggedIn)
        )
      );
    }
    // eslint-disable-next-line
  }, []);

  const { isLoggedIn } = useSelector((state) => state.auth);

  useEffect(() => {
    const storedIsLoggedIn = carMeetStorage && carMeetStorage.isLoggedIn;
    dispatch(auth.setLoggedIn(storedIsLoggedIn));
  }, [isLoggedIn]);

  const isLoggedin =
    isLoggedIn || (carMeetStorage && carMeetStorage.isLoggedIn);

  return (
    <Routes>
      {/* <Route path="auth/*" element={<AuthLayout />} />
      <Route path="/*" element={<AdminLayout />} /> */}
      <Route
        path="auth/*"
        element={
          isLoggedin ? (
            <Navigate to="/dashboard" replace state={{ from: location }} />
          ) : (
            <AuthLayout />
          )
        }
      />
      <Route
        path="/*"
        element={
          isLoggedin ? (
            <AdminLayout />
          ) : (
            <Navigate to="/auth/sign-in" replace state={{ from: location }} />
          )
        }
      />
      {/* <Route path="/" element={<Navigate to="/admin" replace />} /> */}
    </Routes>
  );
};

export default App;
